/** @internal */
export const DateFromSelfSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/DateFromSelf");
/** @internal */
export const GreaterThanSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThan");
/** @internal */
export const GreaterThanOrEqualToSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanOrEqualTo");
/** @internal */
export const LessThanSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThan");
/** @internal */
export const LessThanOrEqualToSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanOrEqualTo");
/** @internal */
export const IntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Int");
/** @internal */
export const NonNaNSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/NonNaN");
/** @internal */
export const FiniteSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Finite");
/** @internal */
export const JsonNumberSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/JsonNumber");
/** @internal */
export const BetweenSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Between");
/** @internal */
export const GreaterThanBigintSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanBigint");
/** @internal */
export const GreaterThanOrEqualToBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanOrEqualToBigint");
/** @internal */
export const LessThanBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanBigint");
/** @internal */
export const LessThanOrEqualToBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanOrEqualToBigint");
/** @internal */
export const BetweenBigintSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/BetweenBigint");
/** @internal */
export const MinLengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MinLength");
/** @internal */
export const MaxLengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MaxLength");
/** @internal */
export const LengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Length");
/** @internal */
export const MinItemsSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MinItems");
/** @internal */
export const MaxItemsSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MaxItems");
/** @internal */
export const ItemsCountSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/ItemsCount");
//# sourceMappingURL=schemaId.js.map